import React from 'react';
import { C, CT, statusColors } from '../constants/theme';
import { useTranslation } from '../i18n/I18nProvider.jsx';

// The appointment status pill — one component, both surfaces.
//
// NOT the kit's <StatusBadge/>: that derives its LABEL from
// `statusColors[status].label`, which is Persian-only — so the day sheet read
// «نوبت‌دار» beside English copy for a dentist working in `en`. Everything
// visual still comes from the kit's tokens; only the word is the catalogue's,
// and a status this app has no copy for renders VERBATIM rather than being
// relabelled — the same fallback the kit uses.
//
// It lives here rather than inside AppointmentRow because the mobile card
// renders the identical pill (§1.1: fork the markup, share the vocabulary). The
// two surfaces disagreeing about what «arrived» is called would be a defect;
// this is the smallest thing they can share to make that impossible.

const NEUTRAL_BG = CT.surface2;

const StatusPill = ({ status, style }) => {
  const { t } = useTranslation();
  const cfg = statusColors[status] || { bg: NEUTRAL_BG, text: C.textSecondary };
  const key = `today.status.${status}`;
  return (
    <span
      style={{
        fontSize: 11,
        fontWeight: 700,
        padding: '3px 10px',
        borderRadius: 20,
        background: cfg.bg,
        color: cfg.text,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {t.has(key) ? t(key) : status || t('common.labels.none')}
    </span>
  );
};

export default StatusPill;
